/* --- SHUBHAM PRODUCT PAGE LOGIC --- */

// 1. Image Gallery Logic
function shubhamChangeImage(thumbElement) {
  const mainImg = document.getElementById('shubham-main-image');
  const newSrc = thumbElement.getAttribute('data-src');
  
  mainImg.src = newSrc;
  
  document.querySelectorAll('.shubham-thumbnail').forEach(th => th.classList.remove('active'));
  thumbElement.classList.add('active');
}

// 2. Quantity Box Logic
function shubhamUpdateQty(change) {
  const input = document.getElementById('shubham-quantity');
  let newVal = parseInt(input.value) + change;
  if (newVal < 1) newVal = 1; 
  input.value = newVal;
}

// 3. Variant Selection Logic
function shubhamSelectVariant(btnElement) {
  if (btnElement.classList.contains('sold-out')) return; // Prevent selecting sold out

  const group = btnElement.closest('.shubham-option-values');
  group.querySelectorAll('.shubham-option-btn').forEach(btn => btn.classList.remove('selected'));
  btnElement.classList.add('selected');

  const selectedOptions = [];
  document.querySelectorAll('.shubham-option-btn.selected').forEach(btn => {
    selectedOptions.push(btn.getAttribute('data-value'));
  });

  const variantDataStr = document.getElementById('shubham-variant-data').textContent;
  const variants = JSON.parse(variantDataStr);
  
  const matchedVariant = variants.find(variant => {
    return selectedOptions.every((val, index) => variant.options[index] === val);
  });

  if (matchedVariant) {
    document.getElementById('shubham-variant-id').value = matchedVariant.id;
    
    // Update Pricing & Free Shipping Badge
    const priceBlock = document.getElementById('shubham-price-block');
    let priceHTML = '';
    
    if (matchedVariant.compare_at_price > matchedVariant.price) {
      priceHTML += `<span class="shubham-price-compare">Rs. ${(matchedVariant.compare_at_price / 100).toFixed(2)}</span>`;
    }
    priceHTML += `<span class="shubham-price-current">Rs. ${(matchedVariant.price / 100).toFixed(2)}</span>`;
    priceHTML += `<span class="shubham-badge-free-shipping">Free Shipping</span>`;
    
    priceBlock.innerHTML = priceHTML;

    // Update Urgency Tag based on exact variant inventory
    const urgencyTag = document.getElementById('shubham-urgency-tag');
    if (matchedVariant.inventory_quantity > 0 && matchedVariant.inventory_quantity <= 10) {
      urgencyTag.innerHTML = `🔥 Just ${matchedVariant.inventory_quantity} left. Order soon!`;
    } else {
      urgencyTag.innerHTML = `🔥 Selling fast!`;
    }

    const url = new URL(window.location);
    url.searchParams.set('variant', matchedVariant.id);
    window.history.replaceState({}, '', url);
  }
}


// 4. NEW: Zoom Hover Effect Logic
function shubhamInitHoverZoom() {
  const wrapper = document.querySelector('.shubham-main-image-wrapper');
  const img = document.getElementById('shubham-main-image');

  if(!wrapper || !img) return;

  // Only run the complex math if we are hovering on desktop
  wrapper.addEventListener('mousemove', function(e) {
    if (window.innerWidth > 768) {
      const rect = wrapper.getBoundingClientRect();
      
      // Calculate cursor position relative to the image container
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Convert to percentages
      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;

      // Move the transform origin to the cursor location
      img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    }
  });

  // Activate zoom on mouse enter
  wrapper.addEventListener('mouseenter', function() {
    if (window.innerWidth > 768) {
      wrapper.classList.add('is-zoomed');
    }
  });

  // Deactivate zoom and reset image to center on mouse leave
  wrapper.addEventListener('mouseleave', function() {
    wrapper.classList.remove('is-zoomed');
    setTimeout(() => {
      if(!wrapper.classList.contains('is-zoomed')) {
         img.style.transformOrigin = '50% 50%';
      }
    }, 150); // slight delay to let the CSS transition finish
  });
}

// Start the zoom listener once the page loads
document.addEventListener('DOMContentLoaded', shubhamInitHoverZoom);